// DS: TODO
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const EditorH4: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM22 8V16H23.5V18H22V20H20V18H14.5V16.66L19.5 8H22ZM20 11.133L17.19 16H20V11.133Z"></path>
      </svg>
    </IconWrap>
  );
};
EditorH4.displayName = 'EditorH4';

export default EditorH4;
